export default __webpack_public_path__ + "static/media/invit.a815b032.svg";